/**
 * ===============================================================================
 * SALAS DE ESPECIALISTA ACCESIBLES POR URL DIRECTA (/sala/:slug)
 * ===============================================================================
 *
 * Cada sala del recorrido inmersivo son en realidad DOS páginas del carrusel
 * de HomePage:
 *
 *   - entryPage:   página de entrada (cinemática, autoAdvance, sin chat).
 *                  Es la que Voiceflow conoce como "sala": los intents
 *                  pageNavigationInfo se envían con ESTE id.
 *   - servicePage: página final donde se abre el widget de chat.
 *
 * Para entrar a una sala hay que navegar SIEMPRE a entryPage: la propia página
 * hace autoAdvance hasta servicePage. Entrar directo a servicePage se saltaría
 * la transición y dejaría a Voiceflow sin contexto de la sala.
 * ===============================================================================
 */

export const ROOMS = {
  'evaluacion-tdah': {
    entryPage: 31,
    servicePage: 32,
    label: 'Evaluación/Test TDAH',
    seoTitle: 'Evaluación y Test de TDAH Online',
    seoDescription: 'Evaluación y diagnóstico de TDAH en adultos con especialistas. Test TDAH online, informe clínico y orientación terapéutica. Primera consulta gratuita.',
    seoKeywords: 'evaluación TDAH, test TDAH adulto, diagnóstico TDAH, TDAH online, informe TDAH'
  },
  'tdah-adultos': {
    entryPage: 33,
    servicePage: 34,
    label: 'TDAH para Adultos',
    seoTitle: 'Tratamiento del TDAH en Adultos',
    seoDescription: 'Terapia y tratamiento del TDAH en adultos online. Abordaje de la desatención, la impulsividad y la desorganización con psicólogos especializados.',
    seoKeywords: 'TDAH adulto, tratamiento TDAH, terapia TDAH, déficit atención adulto, psicólogo TDAH'
  },
  'tdah-familias': {
    entryPage: 35,
    servicePage: 36,
    label: 'Asesoramiento de familias TDAH',
    seoTitle: 'Asesoramiento a Familias con TDAH',
    seoDescription: 'Asesoramiento psicológico a familias que conviven con el TDAH. Pautas de manejo, comunicación y acompañamiento a padres y madres.',
    seoKeywords: 'TDAH familias, asesoramiento familiar TDAH, padres TDAH, pautas TDAH'
  },
  'ansiedad-depresion': {
    entryPage: 21,
    servicePage: 22,
    label: 'Ansiedad y Depresión',
    seoTitle: 'Especialistas en Ansiedad y Depresión',
    seoDescription: 'Terapia psicológica online para ansiedad y depresión. Tratamiento con especialistas, sin esperas y desde casa. Primera consulta gratuita.',
    seoKeywords: 'ansiedad, depresión, terapia ansiedad, psicólogo depresión, terapia online'
  },
  'terapia-parejas': {
    entryPage: 23,
    servicePage: 24,
    label: 'Terapia de Parejas',
    seoTitle: 'Terapia de Parejas Online',
    seoDescription: 'Terapia de pareja online con psicólogos especializados. Comunicación, conflictos y reconstrucción del vínculo. Primera consulta gratuita.',
    seoKeywords: 'terapia de pareja, terapia parejas online, psicólogo pareja, crisis pareja'
  },
  'crecimiento-personal': {
    entryPage: 25,
    servicePage: 26,
    label: 'Crecimiento Personal',
    seoTitle: 'Crecimiento Personal y Autoestima',
    seoDescription: 'Acompañamiento psicológico para el crecimiento personal: autoestima, gestión emocional y desarrollo de objetivos vitales.',
    seoKeywords: 'crecimiento personal, autoestima, desarrollo personal, gestión emocional'
  }
};

export const ROOM_SLUGS = Object.keys(ROOMS);

export const getRoomBySlug = (slug) => (slug ? ROOMS[slug] || null : null);

/**
 * Sala de Voiceflow correspondiente a cada página del carrusel.
 *
 * Tanto la página de entrada como la de servicio pertenecen a la MISMA sala de
 * Voiceflow, y esa sala se identifica por el id de la página de entrada.
 *
 * Esto permite que el intent se envíe aunque el widget de chat todavía no
 * estuviera cargado durante la página de entrada — que es justo lo que ocurre
 * al abrir una sala mediante URL directa (deep link "en frío").
 */
export const VF_ROOM_BY_PAGE = Object.values(ROOMS).reduce((acc, room) => {
  acc[room.entryPage] = room.entryPage;
  acc[room.servicePage] = room.entryPage;
  return acc;
}, {});

/** Slug de la sala a la que pertenece una página (o null si no es una sala) */
export const getSlugByPageId = (pageId) =>
  ROOM_SLUGS.find(
    (slug) => ROOMS[slug].entryPage === pageId || ROOMS[slug].servicePage === pageId
  ) || null;
